<template>
  <!--  专题首页-->
  <div class="topicIndex">
    <div class="topic_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="10">
              <el-form-item label="活动名称">
                <el-input
                  placeholder="请输入标题"
                  v-model="searchDas.activityName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="状态">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="searchDas.examineStatus"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in examineStatus"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="开始时间">
                <el-date-picker
                  clearable
                  end-placeholder="开始日期"
                  range-separator="至"
                  size="small"
                  start-placeholder="开始日期"
                  type="daterange"
                  v-model="value1"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-form-item label="结束时间">
              <el-date-picker
                clearable
                end-placeholder="结束日期"
                range-separator="至"
                size="small"
                start-placeholder="结束日期"
                type="daterange"
                v-model="value2"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button style="margin-left: 120px" type="primary" @click="search"
              >查询</el-button
            >

            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="voteAdd"
              v-if="menuPerm('vote:insert')"
              >添加</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="voteClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card>
        <el-table
          :data="voteList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
        >
          <el-table-column
            prop="activityName"
            label="活动的名称"
            align="center"
            width="200"
            fixed
          >
          </el-table-column>
          <el-table-column
            prop="introduce"
            label="活动介绍"
            align="center"
            width="200px"
          >
          </el-table-column>
          <el-table-column label="链接" prop="linkTo" width="150px">
            <template slot-scope="{ row }">
              <el-button
                @click="copy"
                type="primary"
                class="btns"
                :data-clipboard-text="
                  'https://www.weiguanzixun.com/vote?id=' + row.id
                "
                >复制</el-button
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="coverUrl"
            label="封面图"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="vote_img">
                <img :src="row.coverUrl" alt />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="活动开始时间"
            prop="startDate"
            align="center"
            width="180px"
          ></el-table-column>
          <el-table-column
            label="活动结束时间"
            prop="endDate"
            align="center"
            width="180px"
          ></el-table-column>
          <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="180px"
          >
            <template slot-scope="{ row }">
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                v-if="menuPerm('vote:review')"
                @change="examChange($event, row)"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in examineStatus"
                ></el-option>
              </el-select>

              <div v-if="menuPerm('vote:submitReview')">
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 2"
                  >未提交审核</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  v-if="row.examineStatus == 3"
                  >审核中</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 4"
                  >审核未通过</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.examineStatus == 1"
                  >审核通过</el-button
                >
                <!-- <span v-if="row.examineStatus == 2">未提交审核</span>
                <span v-if="row.examineStatus == 3">审核中</span>
                <span v-if="row.examineStatus == 4">审核未通过</span>
                <span v-if="row.examineStatus == 1">审核通过</span> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="rule"
            label="活动规则"
            align="center"
            width="200px"
          >
          </el-table-column>
          <el-table-column
            prop="limitDay"
            label="上限次数"
            align="center"
            width="200px"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  type="primary"
                  @click="topicEdit(row)"
                  v-if="menuPerm('vote:update')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >修改</el-button
                >

                <el-button
                  @click="handleExamine(row)"
                  size="mini"
                  type="primary"
                  v-if="menuPerm('vote:submitReview')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
                <el-button
                  type="primary"
                  @click="topicDetailed(row)"
                  size="mini"
                  >详情</el-button
                >
                <el-button type="primary" @click="push(row)" size="mini" v-if="menuPerm('app:push')"
                  >推送</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="voteDelate(row)"
                  v-if="menuPerm('vote:delete')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 详情页面 -->
      <a-drawer
        title="活动详情"
        :width="900"
        :visible="detailvisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>

      <!-- 修改页面 -->
      <a-drawer
        title="投票修改"
        :width="900"
        :visible="editvisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Edit :Editdata="editData" />
      </a-drawer>
      <!-- 删除弹框 -->
      <a-modal v-model="visible" on-ok="handleOk">
        <template slot="footer">
          <a-button key="back" @click="handleCancel"> 取消 </a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="handleOk"
          >
            确定
          </a-button>
        </template>
        <p>确定删除吗?</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Edit from "./changeList";
import Detail from "./detail";
import Clipboard from "clipboard";
import { ElementUI, MessageBox } from "element-ui";
export default {
  data() {
    return {
      voteList: [],
      visible: false, //删除弹框
      loading: false,
      detailvisible: false,
      editvisible: false,
      allOpen: true,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      //   查询数据

      searchDas: {
        activityName: "",
        examineStatus: "",
      },
      //状态--下拉框：
      examineStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      value1: "", //查询时间
      value2: "", //查询结束时间
      editData: "",
      detailData: "",
      editvisible: false,
      startDateBegin: "", //活动开始时间-起始
      startDateEnd: "", //活动开始时间-结束
      endDateBegin: "", //活动结束时间-起始
      endDateEnd: "", //活动结束时间-结束
      deleteId: "", //删除的id
    };
  },
  components: {
    Edit,
    Detail,
  },
  methods: {
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 清空查询条件
    voteClear() {
      this.value1 = "";
      this.value2 = "";
      this.searchDas.examineStatus = "";
      this.searchDas.activityName = "";
    },
    onClose() {
      this.detailvisible = false;
      this.editvisible = false;
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-align: center;";
      } else {
        return "";
      }
    },
    // 列表
    getList() {
      this.postAxios("/vote/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        startDateBegin: this.startDateBegin,
        startDateEnd: this.startDateEnd,
        endDateBegin: this.endDateBegin,
        endDateEnd: this.endDateEnd,
        examineStatus: this.searchDas.examineStatus,
        activityName: this.searchDas.activityName,
      }).then((res) => {
        if (res.success) {
          this.voteList = res.content;
          this.totalCount = res.totalCount;
        } else if (res.success && res.statusCode == 401) {
          this.$router.push("/");
          this.$message.error(res.message);
        } else {
          this.$router.push("/");
          this.$message.error(res.message);
        }
      });
    },
    // 查询
    search() {
      if (this.value1 != null) {
        this.startDateBegin = this.value1[0];
        this.startDateEnd = this.value1[1];
      } else {
        this.startDateBegin = "";
        this.startDateEnd = "";
      }
      if (this.value2 != null) {
        this.endDateBegin = this.value2[0];
        this.endDateEnd = this.value2[1];
      } else {
        this.endDateBegin = "";
        this.endDateEnd = "";
      }
      this.getList();
    },
    examChange(val, row) {
      this.getAxios("/vote/review", {
        id: row.id,
        examineStatus: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 添加活动
    voteAdd() {
      this.$router.push("/voteAdd");
    },
    // 删除弹框
    handleCancel() {
      this.visible = false;
    },
    // 删除活动
    voteDelate(row) {
      this.visible = true;
      this.deleteId = row;
    },
    handleOk() {
      this.visible = false;
      this.getAxios("/vote/delete", {
        id: this.deleteId.id,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false && res.statusCode == 401) {
          this.$router.push("/");
          this.$message.error(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 提交审核
    handleExamine(obj) {
      this.getAxios("/vote/submit/review", {
        id: obj.id,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false && res.statusCode == 401) {
          this.$router.push("/");
          this.$message.error(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 9,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 详情
    topicDetailed(obj) {
      this.detailvisible = true;
      this.detailData = obj;
      this.$store.commit("voteDetail", obj.id);
    },
    // 修改
    topicEdit(obj) {
      this.editvisible = true;
      this.editData = obj;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      //   this.multipleSelection = val;
    },
  },

  created() {},
  mounted() {
    this.getList();
    if (this.menuPerm("vote:update_edit") == true) {
      this.allOpen = false;
    }
  },
};
</script>
<style scoped >
.vote_img img {
  width: 100%;
}
.done {
  display: flex;
  flex-direction: column;
  width: 100px;
}
div /deep/ .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100px;
  margin-top: 10px;
  margin-left: 10px;
}
</style>